<script lang="ts">
export default {
    name: 'NavigationPartner',
};
</script>

<script setup lang="ts">
import { PARTNER_REQUEST } from '@/components/user/constants';
import usePartnerRequest from '@/components/user/composables/usePartnerRequest';

const emit = defineEmits<{
    (e: 'navigate'): void;
}>();

const { state, request } = usePartnerRequest();

async function sendPartnerRequest() {
    emit('navigate');

    await request();
}
</script>

<template>
    <base-button
        id="login-button"
        size="small"
        text
        stretch
        :label="$t('partner request')"
        :disabled="state === PARTNER_REQUEST.SENT"
        :icon="{ name: 'handshake', prefix: 'far' }"
        @click="sendPartnerRequest"
    />
</template>
